<template>
  <b-row>
    <b-col>
      <b-row xs="12" v-if="noStays && !loadingStays">
        <md-empty-state
          md-icon="gavel"
          md-label="All your Stays will appear here."
          md-description="You can create a new stay, by surfing the marketplace for a new home."
        >
          <md-button
            class="md-raised md-primary play-cta-button makeup"
            @click="redirectTo('listingsearch')"
          >Go To Market</md-button>
        </md-empty-state>
      </b-row>

      <md-progress-bar md-mode="indeterminate" v-if="loadingStays"></md-progress-bar>
      <md-table v-if="!noStays" v-model="filteredStays" md-sort="name" md-sort-order="asc" md-card>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          @click="viewDeal(item)"
          class="clickable"
        >
          <md-progress-spinner
            v-if="item.loading"
            :md-diameter="30"
            :md-stroke="3"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <md-table-cell
            v-else
            md-label="Property"
            md-sort-by="location"
          >{{getDisplayAddress(item.property.address)}}
          </md-table-cell>

          <md-table-cell
            v-if="!item.loading && !item.contractDetails.terms.periodEnd"
            md-label="Term"
            md-sort-by="period"
          >Move in: {{formatTime(item.contractDetails.terms.periodStart)}}
          </md-table-cell>
          <md-table-cell
            v-else-if="!item.loading"
            md-label="Term"
            md-sort-by="period"
          >{{formatTime(item.contractDetails.terms.periodStart)}} - {{formatTime(item.contractDetails.terms.periodEnd)}}</md-table-cell>
        </md-table-row>
      </md-table>
      <div class="md-layout md-alignment-bottom-center mt-3">
        <div v-if="loadingStays" class="loader-rolling-local_blue"></div>
      </div>
      
      <!-- TODO: Make more awesome, stay cards with property image and other stuff. User stayPreviews.vue for that. -->
      <!-- <b-row
        v-else
        lg="12"
        v-for="(item, index) in stays"
        :key="index+item._id"
        class="dash-element-container"
      >

        <b-row v-if="item.loading">
          <content-loader style="height:155; width:400">
            <rect x="200" y="15" rx="3" ry="3" width="185" height="20" />
            <rect x="200" y="70" rx="3" ry="3" width="113" height="15" />
            <rect x="200" y="105" rx="0" ry="0" width="90" height="40" />
            <rect x="12" y="15" rx="0" ry="0" width="180" height="120" />
            <rect x="310" y="105" rx="0" ry="0" width="90" height="40" />
          </content-loader>
        </b-row>
        <b-container v-else-if="item">
          {{item}}
          <stay-preview
            :deal="item">
          </stay-preview>
        </b-container>
      </b-row> -->
    </b-col>
    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>
  </b-row>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { mapState } from "vuex";
import { composeChatRedirectParams } from "../../chatRepository.js";
import StayPreview from "../../components/dashboard/stayPreview.vue";
import Snackbar from "../../components/snackbar.vue";
import { formatAddress_MuniStreetBuilding_Number } from '@/utils/address/addressUtil.js'
import { formatISOShortToDDMonthYYYY } from "../../timeFunctions.js";
import { debounce } from 'lodash/function';
import { BOOKING_STATUS } from "@/bookings/bookingUtil";

export default {
  props: {},
  components: {
    "stay-preview": StayPreview,
    "content-loader": ContentLoader,
    "error-snackbar": Snackbar
  },
  data() {
    return {
      preLoadingBookings: false,
      showBookingRequestDialog: false,
      bookingRequestPeriodStart: undefined,
      bookingRequestPeriodEnd: undefined,
      disabledBookingDates: [],
      loadingDisabledBookingDates: true,
      currentlyInProcessRequestId: -1,
      showErrorSnackbar: false,
      errorSnackbarMessage: ""
    };
  },
  computed: {
    loadingStays() {
      return this.$store.getters.loadingStays;
    },
    noStays() {
      return (
        !this.$store.getters.stays || this.$store.getters.stays.length == 0
      );
    },
    filteredStays(){
      return this.stays
    },
    stays() {
      return this.orderItems(this.$store.getters.stays);
    },
    bookingIds() {
      return this.$store.getters.tenantStayIds;
    },
    selectedAccountId() {
      if (this.$store.getters.connectedAccountIds.length > 0)
        return this.$store.getters.connectedAccountIds[0];
      return null;
    },
    canLoadMoreStays() {
      return this.$store.getters.canLoadMoreStays;
    }
  },
  watch: {
    selectedAccountId: function(val, oldVal) {
      if (val && val != oldVal)
        this.$store.dispatch("getAccountStays", {
          accountId: this.selectedAccountId
        });
    }
  },
  created() {
    if (!this.stays || this.stays.length == 0) {
      if (this.selectedAccountId) this.getStays();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getStays() {
      this.$store.dispatch("getAccountStays", {
        accountId: this.selectedAccountId
      });
    },
    redirectTo(where) {
      this.$router.push({
        name: where
      });
    },
    reload() {
      this.$store.dispatch("getAccountStays", {
        accountId: this.selectedAccountId,
        reload: true
      });
    },
    orderItems(items) {
      if (items) {
        function compare(a, b) {
          const rA = a.updatedAt;
          const rB = b.updatedAt;

          let comparison = 0;
          if (rA < rB || a.status === BOOKING_STATUS.declined) {
            comparison = 1;
          } else if (rA > rB) {
            comparison = -1;
          }
          return comparison;
        }
        return items.sort(compare);
      }
    },
    isPresentInArray(ar, findMe) {
      if (!ar) return false;
      var len = ar.length;
      var i = 0;
      for (; i < len; ) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    viewDeal(deal) {
      this.$router.push({
        name: "deal",
        params: {
          dealId: deal._id,
          ownerViewingForce: false
        }
      });
    },
    getDisplayAddress(addressObj) {
      return formatAddress_MuniStreetBuilding_Number(addressObj)
    },
    formatTime(dateString) {
      return formatISOShortToDDMonthYYYY(dateString);
    },
    handleScroll: debounce(function (event) {
      if (!this.canLoadMoreStays || this.loadingStays) {
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        return;
      }
      this.getStays();
    }, 100),
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";

.booking-request-content-container {
  padding: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stayPreviews.vue